<script lang="ts" module>
  import { onDestroy } from 'svelte';

  import { StyleCategories, type StyleCategory } from '@/teoCore/text/StyleHandler';
  import type { TeoText } from '@/teoCore/text/TeoText';
  import TpiDrawer from '@/ui/elements/tpi-drawer/TPIDrawer.svelte';
  import { useTeoTextUiStateObserver } from '@/utils/use-teo-event-observer.svelte';

  import { createPillGroups, type StylePillGroup } from './StyleComponent';

  export interface SpellCheckComponentProps {
    teoText: TeoText;
  }
</script>

<script lang="ts">
  let { teoText }: SpellCheckComponentProps = $props();
  const dimensionDrawerOpen = useTeoTextUiStateObserver(teoText.ui, 'dimensionDrawerOpen');
  const category = useTeoTextUiStateObserver(teoText.ui, 'styleCategory');
  const textProperty = useTeoTextUiStateObserver(teoText.ui, 'styleTextProperty');

  let pillgroups: StylePillGroup[] = $state([]);

  const eventListenerRemovers = [teoText.events.addEventListener('gotAnalysis', onAnalysis)];

  onDestroy(() => {
    eventListenerRemovers.forEach((remove) => remove());
  });

  onAnalysis();

  function onAnalysis() {
    pillgroups = createPillGroups(teoText.style);
  }

  function onDimensionChange(dm: string | undefined) {
    if (dm === undefined || (StyleCategories as readonly string[]).includes(dm))
      teoText.ui.update('styleCategory', dm as StyleCategory);
  }

  function onTextPropertyChange(tp: string | undefined) {
    teoText.ui.update('styleTextProperty', tp);
  }
</script>

<TpiDrawer
  open={dimensionDrawerOpen.current}
  pillGroups={pillgroups}
  useableSubdims={['subdim1', 'subdim2', 'subdim3']}
  dimension={category.current}
  textProperty={textProperty.current}
  helpTopicName="style-dimensions"
  {onDimensionChange}
  {onTextPropertyChange}
></TpiDrawer>
